import { AxiosError } from 'axios';

import { WORKBOOK_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { Workbook } from '@/types/workbook.type';

export const getWorkbook = async (): Promise<ApiResponse<Workbook>> => {
  try {
    const response = await apiManager.get(WORKBOOK_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
